import React, { Dispatch, FunctionComponent } from 'react';
import { Typography } from '@material-ui/core';
import GenericAccordion from '../../presentation/genericAccordion/GenericAccordion';
import SectionStatesWrapper from '../../configuratorStates/SectionStatesWrapper';
import variantSelectorBaseStyles from './variantSelectorStyles';
import Translation from '../../translation/Translation';

export interface IVariantSelectorBase {
  expanded: boolean;
  setExpanded: Dispatch<React.SetStateAction<boolean>>;
  error?: Error;
}

const VariantSelectorBase: FunctionComponent<IVariantSelectorBase> = ({ children, setExpanded, expanded, error }) => {
  const styles = variantSelectorBaseStyles();

  return (
    <GenericAccordion
      expanded={expanded}
      setExpanded={setExpanded}
      classes={{ accordionDetails: styles.container }}
      dataTest={'container:section:variant_selector'}
      summary={
        <Typography component="h3" variant="sectionTitle">
          <Translation id="spc.customise.variant" />
        </Typography>
      }
      details={<SectionStatesWrapper error={error}>{children}</SectionStatesWrapper>}
    />
  );
};

export default VariantSelectorBase;
